export default {
  data () {
    return {
      gridApi: null,
      columnApi: null,
      scrollPosition: 0
    }
  },

  methods: {
    saveScrollPosition () {
      if (this.gridApi) {
        const firstVisibleRow = this.gridApi.getFirstDisplayedRow()
        if (firstVisibleRow !== null) {
          this.scrollPosition = firstVisibleRow
        }
      }
    },

    restoreScrollPosition () {
      if (this.gridApi && this.scrollPosition > 0) {
        setTimeout(() => {
          // Add offset of 12 rows to align better with previous view
          const adjustedPosition = this.scrollPosition + 12
          this.gridApi.ensureIndexVisible(adjustedPosition, 'top')
        }, 100)
      }
    },

    onGridReady (params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
    }
  }
}
